import axios from "axios";

const API_URL = process.env.REACT_APP_API_KEY;

const postMembro = async (
  token: string,
  rg: string,
  orgao_expedidor: string,
  cargo: string,
  cep: string,
  cidade: string,
  estado: string,
  rua: string,
  bairro: string,
  numero: string,
  data_inicio_mandato: string | undefined,
  data_fim_mandato: string | undefined,
  representante: boolean,
  user_id: number,
  instituicao_id: number,
  complemento?: string
) => {
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  const response = await axios.post(
    `${API_URL}/membros`,
    {
      rg,
      orgao_expedidor,
      cargo,
      cep,
      cidade,
      estado,
      rua,
      bairro,
      numero,
      complemento,
      data_inicio_mandato,
      data_fim_mandato,
      representante,
      user_id,
      instituicao_id,
    },
    config
  );
  return response.data;
};
export default postMembro;
